import { ColumnOrderState, RowData } from "@tanstack/react-table";

import { IColumnDef } from "@ryde/shared";

interface IColumnOrderResolverInterface<T extends RowData> {
  finalSchemaOrder?: ColumnOrderState;
  columnsDef: IColumnDef<T, unknown>[];
}

export const columnsOrderResolver = <T extends RowData>({
  finalSchemaOrder,
  columnsDef,
}: IColumnOrderResolverInterface<T>): ColumnOrderState => {
  if (finalSchemaOrder?.length) {
    return finalSchemaOrder;
  }

  return columnsDef
    .filter(({ id }) => id !== undefined)
    .map(({ id }) => String(id));
};
